module.exports = __webpack_public_path__ + "images/organizer-68e3c3e5fb2c0f4716e08bc04281e13a.png";